import Vue from 'vue'

function setErrorClassToForm(errorKeys) {
  if (errorKeys.length > 0) {
    errorKeys.map((v) => {
      const nodeList = document.querySelectorAll('input[name='+v+'],textarea[name='+v+'],select[name='+v+']')
      if (nodeList) {
        for (let form of nodeList) {
          form.classList.add("error")
        }
      }
    })
  }
}

function scrollToFirstError() {
  const el = document.querySelector('.error')
  if (el) {
    el.scrollIntoView()
  }
}

export default (data) => {
  const vm = new Vue({
    el: '#form_container',
    data: data,
    methods: {

    },
      watch: {
         'form.zip': function(zip) {
              let _this = this;
             if (8 != zip.length) {
                 return;
             }
              new window.YubinBango.Core(zip, function(addr) {
                  _this.form.pref  = addr.region_id // 都道府県ID
                  _this.form.address1 = addr.locality +  addr.street // 市区町村
              })
          }
      },
      computed: {
      fee: function() {
      }
    },
    mounted: function() {
      setErrorClassToForm(this.errors)
      scrollToFirstError()
    }
  })
}
